import { render, staticRenderFns } from "./StepContainer.vue?vue&type=template&id=21c815b0&scoped=true&"
import script from "./StepContainer.vue?vue&type=script&lang=js&"
export * from "./StepContainer.vue?vue&type=script&lang=js&"
import style0 from "./StepContainer.vue?vue&type=style&index=0&id=21c815b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c815b0",
  null
  
)

export default component.exports